import nestedProperty from 'nested-property';
import * as React from 'react';
import { HeaderContext } from 'telia-front-react';
const HeaderHeightContext = (props) => {
    const [headerBottomHeight, setHeaderBottomHeightState] = React.useState();
    const [headerHeight, setHeaderHeightState] = React.useState();
    const [isHeaderHidden, setIsHeaderHiddenState] = React.useState();
    const setHeaderBottomHeight = (height) => {
        if (nestedProperty.get(window, 'telia.megamenu.setHeaderBottomHeight') && height !== headerBottomHeight) {
            setHeaderBottomHeightState(height);
            window.telia.megamenu.setHeaderBottomHeight(height);
        }
    };
    const setHeaderHeight = (height) => {
        if (nestedProperty.get(window, 'telia.megamenu.setHeaderHeight') && height !== headerHeight) {
            setHeaderHeightState(height);
            window.telia.megamenu.setHeaderHeight(height);
        }
    };
    const toggleHeaderHidden = (isHidden) => {
        if (nestedProperty.get(window, 'telia.megamenu.toggleHeaderHidden') && isHidden !== isHeaderHidden) {
            setIsHeaderHiddenState(isHidden);
            window.telia.megamenu.toggleHeaderHidden(isHidden);
        }
    };
    const providedContext = {
        headerHeight: 0,
        setHeaderHeight,
        headerBottomHeight,
        setHeaderBottomHeight,
        isHeaderHidden,
        toggleHeaderHidden
    };
    return React.createElement(HeaderContext.Provider, { value: providedContext }, props.children);
};
export default HeaderHeightContext;
//# sourceMappingURL=HeaderHeightContext.js.map